












import Header from "@/components/Header.vue";
import { Component, Vue } from "vue-property-decorator";
import { EventBus } from "./event-bus";

@Component({
  components: {
    Header,
  },
 
})
export default class App extends Vue {
  public isLoading= false;
  public fullPage= false;
  public loader= 'spinner';
  get showHeader(): boolean {
    return this.$route.name == "Login" ? false : true;
  }

  created(){
    EventBus.$off('changeUsbStatusModal');
    EventBus.$off('refreshUsbStatus');

    /*EventBus.$on("BeginLoader", (value: any) => {
      this.isLoading = true;
    });
    
    EventBus.$on("FinishLoader", (value: any) => {
      this.isLoading = false;
    });
    */
  }

  
}
